var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphicDocumentEyeDark255(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 255,
    viewBox: "0 0 255 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_1544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.5 212.495C174.441 212.495 212.495 174.441 212.495 127.5C212.495 80.5588 174.441 42.5053 127.5 42.5053C80.5588 42.5053 42.5054 80.5588 42.5054 127.5C42.5054 174.441 80.5588 212.495 127.5 212.495Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.812,
    cy: 84.4688,
    r: 37.25,
    fill: "#292929",
    stroke: "#737373",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3169 28.6875V38.6803M83.3212 33.6919H73.3125",
    stroke: "#737373",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0319 229.564C53.6901 229.564 55.845 227.409 55.845 224.751C55.845 222.092 53.6901 219.938 51.0319 219.938C48.3737 219.938 46.2188 222.092 46.2188 224.751C46.2188 227.409 48.3737 229.564 51.0319 229.564Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.651 142.864C171.133 142.864 173.145 140.852 173.145 138.369C173.145 135.887 171.133 133.875 168.651 133.875C166.168 133.875 164.156 135.887 164.156 138.369C164.156 140.852 166.168 142.864 168.651 142.864Z",
    stroke: "#737373",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.27 143.438L244.274 151.9H234.281L239.286 143.438H239.27Z",
    stroke: "#737373",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.999 68.6866L135.115 77.3407C135.243 77.5479 135.084 77.8188 134.844 77.8188H124.629C124.389 77.8188 124.23 77.5479 124.358 77.3407L129.474 68.6866C129.601 68.4795 129.904 68.4795 130.015 68.6866H129.999Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.118 178.723H127.707V175.312C127.707 174.436 126.99 173.719 126.113 173.719C125.237 173.719 124.52 174.436 124.52 175.312V178.723H121.125C120.248 178.723 119.531 179.44 119.531 180.317C119.531 181.193 120.248 181.911 121.125 181.911H124.536V185.321C124.536 186.198 125.253 186.915 126.129 186.915C127.006 186.915 127.723 186.198 127.723 185.321V181.911H131.134C132.01 181.911 132.727 181.193 132.727 180.317C132.727 179.44 132.01 178.723 131.134 178.723H131.118Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.911 91.6145V90.0226C197.911 88.7687 198.053 87.6837 198.338 86.7499C198.623 85.825 199.103 84.9445 199.779 84.1264C200.455 83.3082 201.371 82.4544 202.518 81.5562C203.701 80.6313 204.643 79.822 205.346 79.1461C206.048 78.4702 206.555 77.7943 206.867 77.1096C207.178 76.4248 207.338 75.6244 207.338 74.7173C207.338 73.2854 206.849 72.1916 205.879 71.4356C204.91 70.6886 203.541 70.3062 201.789 70.3062C200.232 70.3062 198.774 70.5285 197.404 70.9643C196.035 71.4001 194.683 71.9515 193.349 72.6096L191.25 68.154C192.789 67.3092 194.452 66.6333 196.257 66.1175C198.053 65.6017 200.037 65.3438 202.198 65.3438C205.648 65.3438 208.307 66.1797 210.193 67.8517C212.078 69.5236 213.021 71.7291 213.021 74.4683C213.021 75.9712 212.781 77.2607 212.309 78.3368C211.838 79.4129 211.135 80.4001 210.219 81.2983C209.294 82.2054 208.192 83.157 206.884 84.153C205.817 84.9979 205.008 85.7271 204.439 86.3408C203.87 86.9544 203.487 87.5769 203.274 88.1995C203.06 88.822 202.954 89.5779 202.954 90.4584V91.6234H197.911V91.6145ZM196.951 99.7696C196.951 98.3823 197.306 97.4129 198.027 96.8437C198.747 96.2746 199.627 95.9989 200.677 95.9989C201.726 95.9989 202.562 96.2835 203.283 96.8437C204.012 97.4129 204.376 98.3823 204.376 99.7696C204.376 101.157 204.012 102.1 203.283 102.696C202.553 103.291 201.691 103.594 200.677 103.594C199.663 103.594 198.747 103.291 198.027 102.696C197.306 102.1 196.951 101.121 196.951 99.7696Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.155 151.374V170.818C97.155 173.464 95.0034 175.599 92.3737 175.599H19.5234C16.8778 175.599 14.7422 173.448 14.7422 170.818V76.1653C14.7422 73.5197 16.8938 71.3841 19.5234 71.3841H72.3403M72.3403 71.3841L97.155 96.1988V118.001M72.3403 71.3841L72.3401 91.4494C72.3401 94.0791 74.4758 96.2147 77.1055 96.2147H97.1708",
    stroke: "#737373",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6304 134.688C65.6304 134.688 77.0894 118.001 97.1547 118.001C117.22 118.001 128.679 134.688 128.679 134.688C128.679 134.688 117.22 151.374 97.1547 151.374C77.0894 151.374 65.6304 134.688 65.6304 134.688Z",
    stroke: "#0078D7",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.506 130.974C109.506 137.796 103.976 143.342 97.139 143.342C90.3177 143.342 84.7715 137.812 84.7715 130.974C84.7715 124.137 90.3018 118.607 97.139 118.607C103.976 118.607 109.506 124.137 109.506 130.974Z",
    fill: "#0078D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_1544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 255,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicDocumentEyeDark255);
export default __webpack_public_path__ + "static/media/graphic_document-eye-dark-255.90ed1625c3cff9421a874ba0a10cc0c3.svg";
export { ForwardRef as ReactComponent };